// Ключ посетителя (visitor_key): им сервер склеивает реплики в один диалог
// между визитами. Три источника по старшинству:
//   1. data-visitor-key embed-тега — кабинет платформы даёт подписанный ключ
//      АККАУНТА (Channels::Widget::AccountKey): один на человека, а не на
//      браузер, и клиент с телефона и с ноутбука для консультанта — один тред;
//   2. localStorage — обычный сайт, ключ живёт в браузере посетителя;
//   3. свежий ключ на время страницы — localStorage недоступен (приватный режим).
// Ключ из тега в localStorage НЕ пишем: он принадлежит сессии кабинета, а не
// браузеру, и после выхода гость на лендинге — снова аноним.

/** Что принимает сервер (Widget::BaseController::VISITOR_KEY_FORMAT). */
export const VISITOR_KEY_FORMAT = /^[\w-]{8,64}$/;

export interface KeyStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

/**
 * @param publicKey ключ виджета — неймспейс записи в localStorage.
 * @param forced ключ из embed-тега (data-visitor-key); мусор игнорируется.
 * @param storage хранилище (по умолчанию localStorage окна; в тестах — заглушка).
 * @param fresh генератор нового ключа.
 */
export function visitorKeyFor(
  publicKey: string,
  forced: string | undefined,
  storage: () => KeyStorage = () => window.localStorage,
  fresh: () => string = generateVisitorKey,
): string {
  if (forced && VISITOR_KEY_FORMAT.test(forced)) return forced;
  const storageKey = `assiistent_visitor_${publicKey}`;
  try {
    const store = storage();
    const existing = store.getItem(storageKey);
    if (existing) return existing;
    const created = fresh();
    store.setItem(storageKey, created);
    return created;
  } catch {
    // localStorage может быть недоступен (приватный режим) — диалог живёт
    // до перезагрузки страницы.
    return fresh();
  }
}

export function generateVisitorKey(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return `v-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}
